import React from "react";
import {
  CommitmentImageContainer,
  CommitmentImage,
} from "components/Image/Image.styled";
import PropTypes from "prop-types";
import CommitmentText from "./CommitmentText";
import {
  CommitmentContainer,
  CommitmentInnerContainer,
} from "components/Commitment/Commitment.style";
import useDevice from "hooks/useDevice";

const Commitment = (props) => {
  const { isMobile } = useDevice();
  const useReversedLayout = isMobile && props.mobileInverted ? true : props.reverse;

  return (
    <CommitmentContainer container type={props.type} margin={props.margin} width={props.width}>
      {useReversedLayout ? (
        <CommitmentInnerContainer reverse={props.reverse} mobileInverted={props.mobileInverted}>
          <CommitmentText
            iconProperties={props.iconProperties}
            title={props.title}
            text={props.text}
            reverse={props.reverse}
            mobileInverted={props.mobileInverted}
            icon={props.icon}
            button={props.button}
          />
          <CommitmentImageContainer item>
            <CommitmentImage src={props.image} reverse={props.reverse} mobileInverted={props.mobileInverted} />
          </CommitmentImageContainer>
        </CommitmentInnerContainer>
      ) : (
        <CommitmentInnerContainer reverse={props.reverse} mobileInverted={props.mobileInverted}>
          <CommitmentImageContainer item>
            <CommitmentImage src={props.image} reverse={props.reverse} mobileInverted={props.mobileInverted} />
          </CommitmentImageContainer>
          <CommitmentText
            iconProperties={props.iconProperties}
            title={props.title}
            text={props.text}
            reverse={props.reverse}
            mobileInverted={props.mobileInverted}
            icon={props.icon}
            button={props.button}
          />
        </CommitmentInnerContainer>
      )}
    </CommitmentContainer>
  );
};
Commitment.propTypes = {
  image: PropTypes.any,
  title: PropTypes.any,
  text: PropTypes.any,
  reverse: PropTypes.bool,
  mobileInverted: PropTypes.bool,
  type: PropTypes.any,
  icon: PropTypes.any,
  iconProperties: PropTypes.any,
  button: PropTypes.node,
  margin: PropTypes.string,
  width: PropTypes.string,
};
export default Commitment;
